/**
 * Triggers a browser file download for an in-memory blob.
 *
 * Creates a temporary object URL, programmatically clicks an anchor, then
 * revokes the URL. Used by mutations that receive a generated artefact
 * (e.g. a transaction statement export) and need to hand it to the user as
 * a saved file without persisting anything server-side.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = fileName
  anchor.click()
  URL.revokeObjectURL(objectUrl)
}
